export const checkDevEnv = import.meta.env.VITE_NODE_ENV === 'dev' || window.location.hostname === 'neweb.bbservice.lt';
